var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ysb_lxkf"},[_c('span',[_vm._v("联系客服")]),_c('img',{staticClass:"kfImg",attrs:{"src":"https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=ysbkefu.jpg"}})])
}]

export { render, staticRenderFns }